export const root = "r13rdnmt";
export const image = "i1xgtol0";
export const sponsorName = "s14khjk2";
export const sponsorBy = "s1rk89qp";
export const info = "ijlumjs";
export const sponsorNameContainer = "shnok31";
export const logoContainer = "l1pw3enc";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");